module.exports = __webpack_public_path__ + "static/media/hero_img_admissions.59810d28.png";